
ADILF.define('adilf/apps/social/promo-modules/collection-promo-base/views/content-view-factory',['require','exports','module','inherits','streamhub-sdk/content','streamhub-sdk/content/types/livefyre-content','streamhub-sdk/content/types/livefyre-twitter-content','streamhub-sdk/content/types/livefyre-facebook-content','streamhub-sdk/content/types/livefyre-instagram-content','streamhub-sdk/content/types/livefyre-url-content','streamhub-sdk/content/types/twitter-content','streamhub-sdk/content/views/card-content-view','streamhub-sdk/content/views/livefyre-content-view','adilf/apps/social/promo-modules/collection-promo-base/views/twitter-content-view','streamhub-sdk/content/views/facebook-content-view','streamhub-sdk/content/views/instagram-content-view','streamhub-sdk/content/views/url-content-view','streamhub-sdk/content/types/type-urns','streamhub-sdk/content/content-view-factory'],function (require, exports, module) {'use strict';

var inherits = require('inherits');
var Content = require('streamhub-sdk/content');
var LivefyreContent = require('streamhub-sdk/content/types/livefyre-content');
var LivefyreTwitterContent = require('streamhub-sdk/content/types/livefyre-twitter-content');
var LivefyreFacebookContent = require('streamhub-sdk/content/types/livefyre-facebook-content');
var LivefyreInstagramContent = require('streamhub-sdk/content/types/livefyre-instagram-content');
var LivefyreUrlContent = require('streamhub-sdk/content/types/livefyre-url-content');
var TwitterContent = require('streamhub-sdk/content/types/twitter-content');
var ContentView = require('streamhub-sdk/content/views/card-content-view');
var LivefyreContentView = require('streamhub-sdk/content/views/livefyre-content-view');
var TwitterContentView = require('adilf/apps/social/promo-modules/collection-promo-base/views/twitter-content-view');
var FacebookContentView = require('streamhub-sdk/content/views/facebook-content-view');
var InstagramContentView = require('streamhub-sdk/content/views/instagram-content-view');
var UrlContentView = require('streamhub-sdk/content/views/url-content-view');
var TYPE_URNS = require('streamhub-sdk/content/types/type-urns');

var BaseContentViewFactory = require('streamhub-sdk/content/content-view-factory');

var CollectionPromoContentViewFactory = function (opts) {
    opts = opts || {};
    if(!opts.defaultContentView) {
        throw new Error("defaultContentView required");
    }
    BaseContentViewFactory.call(this, opts);
    this.opts = opts;

    this.contentRegistry = [
        { type: LivefyreTwitterContent, view: TwitterContentView,
            typeUrn: TYPE_URNS.LIVEFYRE_TWITTER },
        { type: LivefyreFacebookContent, view: FacebookContentView,
            typeUrn: TYPE_URNS.LIVEFYRE_FACEBOOK},
        { type: LivefyreInstagramContent, view: InstagramContentView,
            typeUrn: TYPE_URNS.LIVEFYRE_INSTAGRAM },
        { type: TwitterContent, view: TwitterContentView,
            typeUrn: TYPE_URNS.TWITTER },
        { type: LivefyreUrlContent, view: UrlContentView,
            typeUrn: TYPE_URNS.LIVEFYRE_URL },
        { type: LivefyreContent, view: opts.defaultContentView,
            typeUrn: TYPE_URNS.LIVEFYRE },
        { type: Content, view: opts.defaultContentView,
            typeUrn: TYPE_URNS.CONTENT }
    ];

};
inherits(CollectionPromoContentViewFactory, BaseContentViewFactory);

CollectionPromoContentViewFactory.prototype.createContentView = function(content, opts) {
    opts = opts || {};
    var ContentViewType = this._getViewTypeForContent(content);
    var attachmentsView = this._createAttachmentsView(content);

    var contentView = new ContentViewType({
        content: content,
        attachmentsView: opts.attachmentsView,
        customConfig: this.opts.customConfig
    });

    return contentView;
};

module.exports = CollectionPromoContentViewFactory;
});
